import { firestore } from "../../config/firebase";
import { doc, updateDoc } from "firebase/firestore";

const updateLog = async (id, obj) => {
  const preActiveLogRef = doc(firestore, "preActiveLogs", id);
  await updateDoc(preActiveLogRef, obj);
};

export default updateLog;